import { isValidDate } from '@monetize/utils/core';
import { isDate } from 'date-fns/isDate';
import { parseISO } from 'date-fns/parseISO';
import { z } from 'zod';

export interface PaymentMethodShareRequestWrapper<T> {
  tenantId: string;
  accountId: string;
  token: string;
  payload: T;
}

export interface PaymentMethodShareInitResponse {
  companyName: string | null;
  companyLogo: string | null;
  accountName: string;
  paymentSetupIntent: {
    clientSecret: string;
    publicKey: string;
  };
}

export const PaymentMethodShareRequestSchema = z.object({
  billGroupId: z.string().nullish(),
  paymentGatewayId: z.string(),
  expiresAt: z.union([z.string(), z.date()]).refine((val) => {
    const date = isDate(val) ? val : parseISO(val);
    return isValidDate(date);
  }, 'Invalid date'),
});

export type PaymentMethodShareRequest = z.infer<
  typeof PaymentMethodShareRequestSchema
>;

export const PaymentMethodTokenRequestSchema =
  PaymentMethodShareRequestSchema.pick({
    billGroupId: true,
    paymentGatewayId: true,
  });

export type PaymentMethodTokenRequest = z.infer<
  typeof PaymentMethodTokenRequestSchema
>;

export const PaymentMethodSaveRequestSchema =
  PaymentMethodShareRequestSchema.pick({
    billGroupId: true,
    paymentGatewayId: true,
  }).extend({
    paymentMethod: z.object({
      amount: z.number().default(0),
      description: z.string().optional(),
      paymentToken: z.string(),
    }),
  });

export type PaymentMethodSaveRequest = z.infer<
  typeof PaymentMethodSaveRequestSchema
>;
